<template>
  <div class="col-lg-12 col-md-12 col-12">
    <div class="itemcard full">
      <h2 class="mgb30">More about our public proxy list page</h2>
      <p>
        This page provides a free proxy list with public proxies scraped from many different
        sources. We scrape thousands of free proxies from all over the internet and check them 24/7
        to make sure you only get the freshest proxies possible. Every proxy gets checked multiple
        times every minute and gets removed if it doesn't work anymore. Our proxy backend with over
        nine proxy checkers and three proxy scrapes updates the proxies every second to make sure
        you get the best free proxy list. This free proxy list provides free socks4, socks5 and HTTP
        proxies and can be downloaded in a text file format (.txt) or can be directly accessed via
        our proxy API.
      </p>
    </div>
  </div>
</template>
